(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaya-footer-exact"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kaya-footer-exact')) {
  customElements.define('kaya-footer-exact', class extends HTMLElement {
    connectedCallback() {
      this.media = window.matchMedia('(max-width: 749px)');
      this.sync = () => {
        this.querySelectorAll('.kf-fold').forEach(details => {
          details.open = !this.media.matches;
          details.querySelector('summary').tabIndex = this.media.matches ? 0 : -1;
        });
      };
      this.media.addEventListener('change', this.sync);
      this.sync();
      if (this.querySelector('.kf-message')) this.querySelectorAll('.kf-message').forEach(message => message.scrollIntoView({block: 'center'}));
    }
    disconnectedCallback() { this.media?.removeEventListener('change', this.sync); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
